import { changeDarkModeReducer } from 'src/store'
import { generalBlue } from 'src/app-config'
import { useDispatch } from 'react-redux'
import { useGetIsDarkMode, useGetIsMobile } from 'src/custom-hooks'

export const DarkModeButton = () => {
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();
    const isMobile = useGetIsMobile();
    
    return (
        <div className={'form-check form-switch'} style={{ bottom: '20px', position: 'fixed', zIndex: 2 }}>
            <input type={'checkbox'}
                id={"darkModeSwitch"}
                className={'form-check-input'}
                checked={isDarkMode}
                onChange={() => dispatch(changeDarkModeReducer())}
            />
            <label htmlFor={'darkModeSwitch'}
                className={'form-check-label'}
                style={{ color: isDarkMode ? 'white' : generalBlue }}
            >
                <b>{isMobile ? '' : (isDarkMode ? "Oscuro" : "Claro")}</b>
            </label>
        </div>
    );
}
